__webpack_require__.p = "/afghan-women-kabul-fall-anniversary/";